import { unidadeService } from '@/services/unidadeService';

const getDefaultState = () => {
  return {
    unidades: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  unidades: state => state.unidades,
  isUnidadesModified: state => !!state.isModified
};

const actions = {
  async fetchUnidades({ commit }) {
    try {
      const response = await unidadeService.getUnidades();
      commit('SET_UNIDADES', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchUnidadesAPI({ commit }) {
    try {
      const response = await unidadeService.getUnidadesAPI();
      commit('SET_UNIDADES', response);
      commit('SET_IS_UNIDADES_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
};

const mutations = {
  CLEAR_UNIDADES_STATE: state => Object.assign(state, getDefaultState()),
  SET_UNIDADES: (state, unidades) => state.unidades = unidades,
  SET_IS_UNIDADES_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}